import React from 'react'
import LineClockDollarIcon from 'components/Luxkit/Icons/line/LineClockDollarIcon'
import Pill from 'components/Luxkit/Pill'
import depositAmountStringBuilder from 'lib/TourV2/depositAmountStringBuilder'
import { useSelector } from 'react-redux'
import { getDefaultDepositAmountPercentage } from 'checkout/selectors/featureConfig/deposit'
import { isOfferDefaultDepositAmountPercentage } from 'lib/depositsUtils'

interface Props {
  depositAmountPercentage?: number
  isGenericValue?: boolean;
  depositType?: Tours.V2OfferDepositType;
  testId?: string;
  depositThresholds?: App.DepositThreshold;
  depositAmount?: number;
}

function SecureWithDepositTag(props: Props) {
  const {
    depositAmountPercentage,
    depositType,
    isGenericValue,
    testId,
    depositThresholds,
    depositAmount,
  } = props

  const defaultDepositAmountPercentage = useSelector(getDefaultDepositAmountPercentage)

  const isOfferUsingDefaultDepositPercentage = isOfferDefaultDepositAmountPercentage(depositThresholds, depositAmount)

  const depositAmountString = isOfferUsingDefaultDepositPercentage ?
    'Secure with a deposit' : !isGenericValue ? `Secure with ${depositAmountPercentage}% deposit` : ` ${depositAmountStringBuilder(defaultDepositAmountPercentage, depositType, depositAmountPercentage).full}`

  return (
    <Pill data-testid={testId} kind="tertiary" variant="primary" startIcon={<LineClockDollarIcon />}>
      {!isGenericValue && depositAmountString}
      {!!isGenericValue && depositAmountString}
    </Pill>
  )
}

export default React.memo(SecureWithDepositTag)
